// src/pages/Search/SearchScreen.js
import React, { useState } from 'react';
import { useApp } from '../../context/AppContext';
import { ArrowLeftIcon, SearchIcon, MapPinIcon } from '../../components/common/Icons';

const SearchScreen = () => {
  const { navigateTo } = useApp();
  const [searchValue, setSearchValue] = useState('');
  const [showLocationDropdown, setShowLocationDropdown] = useState(false);

  // Lista de sugestii de servicii de căutare
  const serviceCategories = [
    { id: 1, name: "Coafor și hairstyling", category: "hairstyling" },
    { id: 2, name: "Frizerie și barber shop", category: "barbershop" },
    { id: 3, name: "Unghii cu gel - Nails", category: "nails" },
    { id: 4, name: "Cosmetică", category: "cosmetics" },
    { id: 5, name: "Extensii gene - Lashes", category: "lashes" },
    { id: 6, name: "Epilare definitivă", category: "hair-removal" }
  ];

  // Lista orașelor disponibile
  const cities = [
    { id: 1, name: "Locația ta", isCurrentLocation: true },
    { id: 2, name: "București" },
    { id: 3, name: "Craiova" },
    { id: 4, name: "Cluj-Napoca" },
    { id: 5, name: "Brașov" },
    { id: 6, name: "Constanța" }
  ];

  // Funcție pentru a gestiona căutarea după introducerea unui termen
  const handleSearch = () => {
    navigateTo('searchResults', { searchTerm: searchValue });
  };

  // Funcție pentru a selecta o categorie de servicii
  const handleCategorySelect = (category) => {
    navigateTo('searchResults', { category: category });
  };

  // Funcție pentru a selecta un oraș
  const handleCitySelect = (city) => {
    // Ar trebui implementat pentru a actualiza locația în context
    console.log('City selected:', city);
    setShowLocationDropdown(false);
  };

  const toggleLocationDropdown = () => {
    setShowLocationDropdown(!showLocationDropdown);
  };

  return (
    <div className="flex flex-col h-full bg-white">
      <header className="p-4 flex items-center">
        <button 
          className="mr-4"
          onClick={() => navigateTo('home')}
        >
          <ArrowLeftIcon size={24} />
        </button>
        <h1 className="text-xl font-medium">Caută</h1>
      </header>

      <div className="p-4">
        <div className="flex rounded-md border border-gray-300 p-2 items-center mb-4">
          <SearchIcon size={20} className="text-gray-500 ml-2 mr-2" />
          <input
            className="flex-1 outline-none"
            placeholder="Caută salon sau serviciu"
            value={searchValue}
            onChange={(e) => setSearchValue(e.target.value)}
            onKeyDown={(e) => e.key === 'Enter' && handleSearch()}
          />
        </div>

        {!showLocationDropdown ? (
          <div 
            className="flex rounded-md border border-blue-600 p-4 items-center mb-4 text-blue-600"
            onClick={toggleLocationDropdown}
          >
            <MapPinIcon size={20} className="mr-2" />
            <span className="flex-1">{showLocationDropdown ? 'Alege orașul' : 'Locația ta'}</span>
          </div>
        ) : (
          <div className="flex flex-col rounded-md border border-blue-600 mb-4 overflow-hidden">
            <div 
              className="flex p-4 items-center bg-blue-50 text-blue-600 border-b border-blue-200"
              onClick={toggleLocationDropdown}
            >
              <MapPinIcon size={20} className="mr-2" />
              <span className="flex-1">Alege orașul</span>
            </div>
            <div className="p-2">
              {cities.map(city => (
                <div 
                  key={city.id}
                  className="flex items-center p-3 hover:bg-gray-50 cursor-pointer"
                  onClick={() => handleCitySelect(city)}
                >
                  {city.isCurrentLocation ? (
                    <div className="w-8 h-8 flex items-center justify-center text-blue-600">
                      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M12 2L4 12H9V21H15V12H20L12 2Z" fill="currentColor"/>
                      </svg>
                    </div>
                  ) : (
                    <MapPinIcon size={20} className="w-8 text-gray-500" />
                  )}
                  <span>{city.name}</span>
                </div>
              ))}
            </div>
          </div>
        )}

        {/* Lista de categorii sugerate */}
        <div className="mt-4">
          {serviceCategories.map(category => (
            <div 
              key={category.id}
              className="flex items-center p-4 border-b hover:bg-gray-50 cursor-pointer"
              onClick={() => handleCategorySelect(category.category)}
            >
              <SearchIcon size={20} className="text-gray-500 mr-3" />
              <span>{category.name}</span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default SearchScreen;